/**
 * Guarantors Redux Slice
 */
import { createSlice } from '@reduxjs/toolkit';

const guarantorSlice = createSlice({
  name: 'guarantors',
  initialState: {
    guarantors: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { clearError } = guarantorSlice.actions;
export default guarantorSlice.reducer;
